import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'brand_reviews-review_section_scroll_to-action_category_scroll';

/**
 * This event first when the user scrolls down on the brand or product page to the spot where the reviews WOULD be, thus triggering the download of the lazy review list.

Using this event along with the review section view event should allow us to see what the dropoff is when the chunk is loading.

Params:
1. View: one of page-product-logged-in, page-product-logged-out, page-brand-logged-in, page-brand-logged-out
2. Retailer token, empty if logged-out
3. Product token, empty if navigating in the brand page
4. Brand token, empty if navigating in the product page
 */
export function trackBrandReviewsReviewSectionScrollToActionCategoryScroll(
  view: string,
  retailerToken: string,
  productToken: string,
  brandToken: string,
  brandToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { view, retailerToken, productToken, brandToken, brandToken2 },
  });
}
